import { NavLink, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, Workflow, Plus, BarChart3, Plug, Settings, LogOut, Store, MessageCircle, Users, Shield } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const items = [
  { to: "/app/dashboard", label: "Tableau de bord", icon: LayoutDashboard, testid: "sidebar-dashboard" },
  { to: "/app/whatsapp", label: "WhatsApp", icon: MessageCircle, testid: "sidebar-whatsapp", highlight: true },
  { to: "/app/workflows", label: "Workflows", icon: Workflow, testid: "sidebar-workflows" },
  { to: "/app/workflows/new", label: "Nouveau workflow", icon: Plus, testid: "sidebar-new-workflow" },
  { to: "/app/marketplace", label: "Marketplace", icon: Store, testid: "sidebar-marketplace" },
  { to: "/app/analytics", label: "Analytics & ROI", icon: BarChart3, testid: "sidebar-analytics" },
  { to: "/app/integrations", label: "Intégrations", icon: Plug, testid: "sidebar-integrations" },
  { to: "/app/team", label: "Équipe & rôles", icon: Users, testid: "sidebar-team" },
  { to: "/app/settings", label: "Paramètres", icon: Settings, testid: "sidebar-settings" },
];

const adminItem = { to: "/app/admin", label: "Admin", icon: Shield, testid: "sidebar-admin", adminOnly: true };

export default function DashboardSidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <aside
      className="w-64 shrink-0 border-r border-zinc-200 bg-white min-h-screen flex flex-col"
      data-testid="dashboard-sidebar"
    >
      <div className="h-16 flex items-center px-6 border-b border-zinc-200">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-7 h-7 klein-bg rounded-sm flex items-center justify-center">
            <span className="font-display text-white font-bold text-sm">F</span>
          </div>
          <span className="font-display font-semibold tracking-tight">FlowMind</span>
        </Link>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        {[...items, ...(user?.is_admin ? [adminItem] : [])].map((it) => {
          const Icon = it.icon;
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end
              data-testid={it.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors ${
                  isActive
                    ? "bg-black text-white"
                    : it.highlight
                      ? "text-emerald-700 hover:bg-emerald-50 bg-emerald-50/50"
                      : "text-zinc-700 hover:bg-zinc-100"
                }`
              }
            >
              <Icon size={16} strokeWidth={1.5} />
              {it.label}
              {it.highlight && (
                <span className="ml-auto text-[9px] font-mono px-1.5 py-0.5 bg-emerald-600 text-white rounded-sm">NEW</span>
              )}
            </NavLink>
          );
        })}
      </nav>

      <div className="p-4 border-t border-zinc-200">
        <div className="mb-3 px-2 py-2 rounded-sm bg-zinc-100 flex items-center justify-between">
          <span className="text-[11px] text-zinc-600">Commandes</span>
          <span className="font-mono text-[10px] text-zinc-500 border border-zinc-300 bg-white rounded-sm px-1.5 py-0.5">⌘K</span>
        </div>
        <div className="flex items-center gap-3 px-2 py-2 rounded-sm mb-2">
          <div className="w-8 h-8 rounded-full klein-bg flex items-center justify-center text-white font-mono text-xs">
            {user?.full_name?.[0]?.toUpperCase() ?? "U"}
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-xs font-medium truncate">{user?.full_name}</p>
            <p className="text-[11px] text-zinc-500 truncate">{user?.email}</p>
          </div>
        </div>
        <button
          onClick={() => { logout(); navigate("/"); }}
          className="w-full flex items-center gap-3 px-3 py-2 rounded-sm text-sm text-zinc-700 hover:bg-zinc-100 transition-colors"
          data-testid="sidebar-logout"
        >
          <LogOut size={16} strokeWidth={1.5} /> Déconnexion
        </button>
      </div>
    </aside>
  );
}
